import { Box, Card, CardContent, LinearProgress, Typography } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import formatFileSize from 'src/util/formatFileSize';

const FilePreview = ({ name = '', size = '', loaded }) => {
  return (
    <Card>
      <CardContent>
        <Box display="flex">
          <Box mr={'1rem'} display="flex" justifyContent="center" alignItems="center">
            <InsertDriveFileIcon />
          </Box>
          <Box>
            <Typography>{name}</Typography>
            <Typography variant="caption" color="text.secondary">
              {formatFileSize(size)}
            </Typography>
          </Box>
        </Box>

        {!loaded && (
          <Box sx={{ width: '100%', mt: '1rem' }}>
            <LinearProgress />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default FilePreview;
